import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Box, Inline } from '@styleseat/ui';
import { useJanitor } from '../../../../hooks/useJanitor';
import { useResponsive } from '../../../../hooks/useResponsiveEffect';
import analytics from '../../../../modules/analytics';
import { ClockThreeIcon } from '../../../ui/Icons';
import { SignupCountdownText } from './SignupCountdownText';
import { useSignupCountdownInfo } from './useSignupCountdownInfo';

export const VIEW_EVENT = 'pro_onboarding_carousel_signup_countdown_viewed';

/**
 * This container is for re-using the SignupCountdownText
 * within the OnboardingCarousel.
 */
const SignupCountdownTextContainer = ({ provider }) => {
  const janitor = useJanitor();
  const { desktopNarrow, desktop, wide } = useResponsive();
  const [hasViewed, setHasViewed] = useState(false);

  const signupInfo = useSignupCountdownInfo(provider);

  if (!signupInfo.showCountdown || !signupInfo.cutoff) {
    return null;
  }

  if (!hasViewed) {
    janitor.addPromise(analytics.track(VIEW_EVENT));
    setHasViewed(true);
  }

  const days = moment.duration(signupInfo.cutoff.diff(moment())).days();

  return (
    <Box paddingY={8}>
      <Inline>
        <Box
          paddingTop={2}
          paddingBottom={12}
          paddingLeft={12}
          paddingRight={8}
        >
          <ClockThreeIcon />
        </Box>
        <Box
          maxWidth="82%"
          paddingTop={desktopNarrow || desktop || wide ? 8 : 4}
          paddingBottom={12}
        >
          <SignupCountdownText days={days} />
        </Box>
      </Inline>
    </Box>
  );
};

SignupCountdownTextContainer.propTypes = {
  provider: PropTypes.shape({
    creation_time: PropTypes.string,
    is_profile_complete: PropTypes.bool,
  }),
};

SignupCountdownTextContainer.defaultProps = {
  provider: null,
};

export default SignupCountdownTextContainer;
